import { getFormMapper, AnswerData, ExtractedFieldData, CoiSubcategory } from './formMapper';

export function detectSubcategory(answersData: AnswerData[]): CoiSubcategory | null {
  const coiMapper = getFormMapper('coi');
  if (!coiMapper) return null;
  
  const category = coiMapper.detectCategory(answersData);
  return category as CoiSubcategory | null;
}

export function getFieldsForSubcategory(subcategory: CoiSubcategory): readonly string[] {
  const coiMapper = getFormMapper('coi');
  if (!coiMapper) return [];
  
  return coiMapper.getFieldsForCategory(subcategory);
}

export function getFieldLabel(translationKey: string): string {
  const coiMapper = getFormMapper('coi');
  if (!coiMapper) return translationKey;
  
  return coiMapper.getFieldLabel(translationKey);
}

export function getFieldTranslationKey(translationKey: string): string {
  const coiMapper = getFormMapper('coi');
  if (!coiMapper) return translationKey;
  
  return coiMapper.getTranslationKey(translationKey);
}

export function extractCoiFieldValues(answersData: AnswerData[], subcategory: CoiSubcategory): ExtractedFieldData {
  const coiMapper = getFormMapper('coi');
  if (!coiMapper) return {};
  
  return coiMapper.extractFields(answersData, subcategory);
}
